"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _require = require("./internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../node-type"),
    CDATA_SECTION_NODE = _require2.CDATA_SECTION_NODE,
    TEXT_NODE = _require2.TEXT_NODE; //
// https://dom.spec.whatwg.org/#concept-child-text-content
//


exports.childTextContent = function (node) {
  var result = "";
  var iterator = domSymbolTree.childrenIterator(node);

  var _iterator = _createForOfIteratorHelper(iterator),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (child.nodeType === TEXT_NODE || // The CDataSection extends Text.
      child.nodeType === CDATA_SECTION_NODE) {
        result += child.data;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
};